import styled from "styled-components";

import { GREEN } from "../../../styles";

export const TabLink = styled.a<any>`
  color: ${(props) => (props.activeTab ? "white" : "black")}! important;
  background-color: ${(props) => (props.activeTab ? GREEN : "")}! important;
  cursor: pointer;
`;

export const PageContainer = styled.div`
  padding: 20px 0;
  position: relative;
  min-height: 200px;
`;